import React, { useState, useEffect } from "react";
import defaultImg from "../../images/defaultimg.png";
import * as moment from "moment";
import tick from "../../images/check-mark@2x.png";
import DefaultRepository from "../../Repository/DefaultRepository";
import { toast } from "react-toastify";
import DialogComponent from "../reusableComponents/Dialog";
import { useHistory } from "react-router-dom";
import { Select } from "@mui/material";
import { TextField, MenuItem, FormControl, Button } from "@mui/material";
import { Box, Grid, Stack, Typography } from "@mui/material";
import { ItemBox, TableHead, TableValues } from "./styles";
import Loader from "../components/Loader";
import { BodyContainer, ButtonAdd, Header, TopGrid } from "../styles";
import Search from "../components/Search";

function WarehouseDetail(props) {
  const { shopName } = props.location.state;
  console.log(props.location.state);
  const history = useHistory();
  const [items, setItems] = useState({
    searchText: "",
    items: [],
    noItems: "",
    loading: false,
    selected: [],
    currentShop: "",
    shops: [],
  });
  console.log(items);
  console.log('itemselected', items.selected)
  console.log('itemselected', items.selected.map((item) => item.transferTo).join(', '))
  let transferItemTo =items.selected.map((item) => item.transferTo).join(', ');
  console.log(transferItemTo);
  console.log('shops', items.shops);
  const [modal, setModal] = useState(false);

  useEffect(() => {
    getItems();
    if (props?.location?.state?.shops) {
      const filtered = props.location.state.shops.filter(
        (item) => item.shop_code != props.location.state.shop_code
      );
      setItems((prev) => ({
        ...prev,
        currentShop: props.location.state.shop_code,
        shops: filtered,
      }));
    }
  }, []);
 


  const transferToInventory = async () => {
    setItems((prev) => ({ ...prev, loading: true }));
    let { data } = await DefaultRepository.defaultModel({
      request: {
        method: "transferItemsWarehouseToInventory",
        data: {
          _id: items.selected[0]._id,
          shop_code:items.selected[0].shop_stock[0].shop_code,
          transferQuantity:items.selected[0].transferQuantity,
        },
      },
   
    });
    console.log(data);
  };


  
  const getItems = async () => {
    setItems((prev) => ({ ...prev, loading: true }));
    let { data } = await DefaultRepository.defaultModel({
      request: {
        method: "getInventoryByShop",
        data: {
          company_code: localStorage.getItem("companyCode"),
          shop_code: props.location.state.shop_code,
        },
      },
    });
    console.log('getData',data);
    data?.response?.data?.items.forEach((item) => {
      item.selected = false;
    });
    setItems((prev) => ({
      ...prev,
      items: data.response.data.items,
      loading: false,
    }));
  };

  const toggle = () => {
    setModal((prev) => !prev);
  };
  const getStockQuantity = (item) => {
    return item?.shop_stock.find((x) => x.shop_code == items.currentShop);
  };

  const toggleSelect = (id) => {
    let copyItems = JSON.parse(JSON.stringify(items.items));
    let foundItem = copyItems.find((found) => found._id == id);

    if (foundItem.selected == true) {
      foundItem.selected = false;
    } else if (foundItem.selected == false) {
      foundItem.selected = true;
    }
    let filtered = copyItems.filter((found) => found.selected == true);
    setItems((prevState) => ({
      ...prevState,
      items: copyItems,
      selected: filtered,
    }));
  };
  const transfertoShop = () => {
    
    console.log(items.selected);
     
    let found = items.selected.find(

      (foundItem) =>
        foundItem.transferQuantity == "" ||
        foundItem.transferTo == "" ||
        foundItem.transferTo == undefined ||
        foundItem.transferQuantity == undefined
    );
    if (found) {
      toast.configure();
      toast.info("Please Fill All fields", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }
    setItems((prevState) => ({ ...prevState, loading: true }));
    items.selected.forEach(async (eachItem) => {
      let item = JSON.parse(JSON.stringify(eachItem));
      let shopQuantity = item?.shop_stock.find(
        (x) => x.shop_code == items.currentShop
      );
      let index = item.shop_stock.findIndex(
        (x) => x.shop_code == items.currentShop
      );

      item.shop_stock[index].shop_quantity =
        parseInt(shopQuantity.shop_quantity) - parseInt(item.transferQuantity);
      let foundItem = item.shop_stock.find(
        (found) => found.shop_code == item.transferTo
      );
      if (foundItem) {
        foundItem.shop_quantity =
          parseInt(foundItem.shop_quantity) + parseInt(item.transferQuantity);
      } else {
        let newEntry = {
          shop_code: parseInt(item.transferTo),
          shop_quantity: parseInt(item.transferQuantity),
        };
        item.shop_stock.push(newEntry);
      }
      delete item.transferQuantity;
      delete item.transferTo;
      item.selected = false;
      item.transferDate = Math.floor(Date.now() / 1000);

   
   console.log('item.transferTo', item.transferTo);
   if(transferItemTo == "inventory") {
    transferToInventory()
   }else {
    await DefaultRepository.defaultModel({
      request: {
        method: "updateItem",
        data: {
          item: { ...item },
          action: "Updated",
          user: localStorage.getItem("token"),
        },
      },
    });
   }
    
   
  
    });

    setItems((prevState) => ({
      ...prevState,
      selected: [],
      loading: false,
    }));
    history.push("/inventory/admin/warehouses");
    toggle();
  };

  const transferItems = () => {

    let foundItem = items.items.find((found) => found.selected == true);
    console.log('foundItem', foundItem);
    if (foundItem) {
      toggle();
    } else {
      toast.configure();
      toast.info("Please Select Items First", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };

  const handleInput = (index) => (e) => {
    console.log('in',index);
    console.log('e.target.name',e.target.name);
    console.log('e.target.value',e.target.value);
    let copySelected = JSON.parse(JSON.stringify(items.selected));
    copySelected[index][e.target.name] = e.target.value;
    setItems((prevState) => ({ ...prevState, selected: copySelected }));
    console.log('Items', items)
  };
  const backToWarehouses = () => {
    history.push("/inventory/admin/warehouses");
  };

  const handleSearch = (e) => {
    const { name, value } = e.target;
    setItems((prev) => ({ ...prev, [name]: value }));
  };

  const searchItems = () => {
    if (items.searchText) {
      const filtered = items.items.filter((item) =>
        item?.name.toString().toLowerCase().includes(items.searchText)
      );
      return filtered;
    } else {
      return items.items;
    }
  };

  return (
    <Box>
      <Header sx={{ mt: { md: "0px", xs: "40px" } }}>
        <TopGrid container alignItems="center" spacing={1}>
          <Grid
            item
            md={3}
            xs={12}
            style={{ marginLeft: "-16px" }}
            className="ml-n-16"
          >
            <Search
              name={"searchText"}
              text={"Search warehouse..."}
              value={items.searchText}
              onChange={handleSearch}
            />
          </Grid>
          <Grid align="center" item lg={6} md={4} xs={12}>
            <Typography variant="h5" sx={{ color: "white" }}>
              {shopName || "Warehouse Details"}
            </Typography>
          </Grid>
          <Grid align="center" item lg={1} md={2} xs={4}>
            <ButtonAdd
              variant="contained"
              fullWidth
              onClick={backToWarehouses}
              className="ml-n-16"
            >
              Back
            </ButtonAdd>
          </Grid>
          <Grid align="center" item lg={2} md={3} xs={8}>
            <ButtonAdd
              variant="contained"
              sx={{ width: { md: "100%", xs: "75%" } }}
              onClick={transferItems}
            >
              Transfer To
            </ButtonAdd>
          </Grid>
        </TopGrid>
      </Header>

      <BodyContainer sx={{ position: "relative", top: "40px" }}>
        {searchItems().map((item, index) => {
          return (
            <ItemBox container key={index}>
              <Grid item xs={2}>
                <Stack
                  direction="row"
                  width="100%"
                  justifyContent="space-evenly"
                  style={{ marginLeft: "-12px" }}
                >
                  <img width="30px" src={item.selected ? tick : ""} />

                  <img height="30px" src={defaultImg} alt="img" />
                </Stack>
              </Grid>
              <Grid
                sx={{ cursor: "pointer" }}
                onClick={() => toggleSelect(item._id)}
                item
                xs={5}
              >
                <Typography
                  sx={{ color: "#4EAF50" }}
                  variant="h6"
                  className="fs-12"
                >
                  {item.name}
                </Typography>

                {window.innerWidth <= 799 && (
                  <Typography className="fs-12">Price: {item.price}</Typography>
                )}
                <Typography>{item.description}</Typography>
                {item.transferDate ? (
                  <Typography className="fs-12">
                    Transfer At:
                    {moment.unix(item?.transferDate).format("DD-MM-YYYY")}
                  </Typography>
                ) : (
                  <Typography className="fs-12">
                    Updated At:
                    {moment.unix(item?.modified_at).format("DD-MM-YYYY")}
                  </Typography>
                )}
              </Grid>
              <Grid item xs={2}>
                {window.innerWidth >= 800 && (
                  <Typography className="fs-12">
                    Sale Price: {item.price}
                  </Typography>
                )}
                {item.costPrice != undefined && window.innerWidth >= 800 && (
                  <Typography className="fs-12">
                    Cost Price: {item.costPrice}
                  </Typography>
                )}
                <Typography className="fs-12">
                  Code: {item.itemCode || item.itemId}
                </Typography>
                {item.vendor != undefined && window.innerWidth >= 800 && (
                  <Typography className="fs-12">
                    Items Brands: {item.vendor}
                  </Typography>
                )}
              </Grid>
              <Grid align="center" item xs={3}>
                <Typography sx={{ color: "#4EAF50" }} className="fs-12">
                  Quantity
                </Typography>
                <Typography sx={{ color: "#4EAF50" }} className="fs-12">
                  {getStockQuantity(item).shop_quantity || 0}
                </Typography>
              </Grid>
            </ItemBox>
          );
        })}

        {!items.loading && items.items.length == 0 && (
          <Stack alignItems="center" justifyContent="center">
            <Typography sx={{ color: "#4EAF50" }} variant="h4">
              No Items
            </Typography>
          </Stack>
        )}
        <Loader loading={items.loading} />
      </BodyContainer>
      <DialogComponent
        title="Transfer Items"
        open={modal}
        onClose={toggle}
        dialogContent={
          <>
            <Typography>
              Select warehouse to whom you want to transfer items
            </Typography>

            <TableHead>
              <Typography>Item Name</Typography>
              <Typography>Quantity</Typography>
              <Typography>Select Shop</Typography>
            </TableHead>
            {items?.selected.map((item, index) => {
              return (
                <TableValues key={index}>
                  <Typography>{item.name}</Typography>
                  <TextField
                    required
                    displayEmpty
                    size="small"
                    type="number"
                    variant="outlined"
                    name="transferQuantity"
                    value={item.transferQuantity}
                    onChange={handleInput(index)}
                  />
                  <FormControl
                    style={{ margin: "3px", minWidth: 120 }}
                    size="small"
                  >
                    <Select
                      required
                      displayEmpty
                      variant="outlined"
                      inputProps={{ "aria-label": "Without label" }}
                      value={item.transferTo}
                      name="transferTo"
                      onChange={handleInput(index)}
                    >
                      <MenuItem value="">Select Shop</MenuItem>
                      <MenuItem value="inventory" >Transfer To inventory</MenuItem>
                      {items?.shops.map((shop, i) => (
                          <MenuItem key={i} value={shop.shop_code}>
                            {shop.shopName}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </TableValues>
              );
            })}
            <Loader loading={items.loading} />

            {!items.loading && (
              <Button
                variant="contained"
                sx={{
                  mt: 2,
                  color: "white",
                  cursor: "pointer",
                  borderRadius: "6px",
                }}
                onClick={transfertoShop}
              >
                Transfer Items
              </Button>
            )}
          </>
        }
      />
    </Box>
  );
}

export default WarehouseDetail;
